import { render, staticRenderFns } from "./header-component.vue?vue&type=template&id=5042e642&scoped=true&"
import script from "./header-component.vue?vue&type=script&lang=js&"
export * from "./header-component.vue?vue&type=script&lang=js&"
import style0 from "./header-component.vue?vue&type=style&index=0&id=5042e642&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5042e642",
  null
  
)

export default component.exports